<template>
  <div class="thread" :id="`thread-${thread.id}`">
    <div class="card">
      <div class="reply">
        <div
          class="d-flex mb-0 mt-2"
          v-if="!oneLiner || depth === 0"
        >
          <slot name="before-header" />
          <div class="ml-4">
            <div class="content mb-2">
              {{ this.thread.content }}
            </div>
            <div class="header">
              <Avatar
                :user-id="thread.userId"
                :size="24"
                v-if="depth === 0"
              />
              <div class="name mx-2">
                {{ userFullName }}
              </div>
              <div class="date">
                {{ moment(this.thread.modifiedOn) }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="one-liner"
        >
          <OneLinerThread
            :thread="this.thread"
          />
        </div>
        <div class="input" v-if="!oneLiner">
          <ThreadInput
            @save="save"
            v-if="depth < maxDepth"
          />
        </div>
      </div>
    </div>
    <div v-if="hasChildren && depth < maxDepth">
      <Thread
        v-for="child in replies"
        :key="child.id"
        :thread="child"
        @save="save"
        :depth="depth + 1"
        :one-liner="oneLiner"
      />
    </div>
    <div class="input" v-if="oneLiner">
      <ThreadInput
        @save="save"
        v-if="depth < maxDepth"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { types as userTypes } from '../../../../store/user';
import { types as usersTypes } from '../../../../store/users';
import ThreadInput from './ThreadInput';
import OneLinerThread from './OneLinerThread';
import Avatar from '../../../avatar/Avatar';

export default {
  name: 'Thread',
  components: {
    ThreadInput,
    OneLinerThread,
    Avatar,
  },
  props: {
    oneLiner: {
      type: Boolean,
      default: false,
    },
    thread: {
      type: Object,
      required: true,
    },
    maxDepth: {
      type: Number,
      default: 1,
    },
    replies: {
      type: Array,
      default: () => [],
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      user: userTypes.getters.userDetails,
      userName: usersTypes.getters.userName,
    }),
    hasChildren() {
      return this.replies.length > 0;
    },
    userFullName() {
      return this.userName(this.thread.userId);
    },
  },
  methods: {
    moment(date) {
      return moment(date).calendar();
    },
    save(content) {
      this.$emit('save', { content, threadId: this.thread.id });
    },
  },
};
</script>
<style scoped>
.thread {
  --padding-left: 50px;
}

.thread .thread {
  margin-left: 22px;
  margin-top: 11px;
}

.content {
  font-size: 13px;
}

.card {
  display: flex;
  width: 100%;
  flex: 1;
}

.header {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.header .date {
  font-size: 10px;
  color: #8F979F;
}

.one-liner .one-liner {
  padding-left: var(--padding-left);
}

.input {
  padding-left: var(--padding-left);
  margin-top: 11px;
}

.reply {
  flex: 1;
}
</style>
